import { render, staticRenderFns } from "./UnpauseView.vue?vue&type=template&id=2a370231&"
import script from "./UnpauseView.vue?vue&type=script&lang=js&"
export * from "./UnpauseView.vue?vue&type=script&lang=js&"
import style0 from "./UnpauseView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports